import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Rect, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface ApplePayIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const ApplePayIcon: React.FC<ApplePayIconProps> = ({
  size = 80,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg
      {...props}
      width={size}
      height={size / 1.6}
      viewBox="0 0 38 24"
      fill="none"
    >
      <Rect
        x="0.5"
        y="0.5"
        width="37"
        height="23"
        rx="2.5"
        stroke={colors[color]}
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2918 7.54747C10.6214 7.1309 10.8451 6.57157 10.7861 6C10.3035 6.02424 9.71467 6.32164 9.37374 6.73854C9.06762 7.09554 8.79667 7.67829 8.86731 8.2259C9.40901 8.27337 9.95022 7.95235 10.2918 7.54747ZM10.7801 8.33281C10.3016 8.30401 9.86667 8.47712 9.51481 8.61718C9.28819 8.70739 9.09601 8.78388 8.94884 8.78388C8.78654 8.78388 8.58707 8.70424 8.36271 8.61466C8.06742 8.49676 7.729 8.36163 7.37543 8.36818C6.56556 8.38019 5.8141 8.84281 5.40312 9.57859C4.55782 11.0505 5.18005 13.2339 6.00206 14.4327C6.40125 15.0258 6.88234 15.6788 7.51625 15.6554C7.79383 15.6444 7.99319 15.5594 8.19969 15.4714C8.43874 15.3695 8.68736 15.2635 9.07798 15.2635C9.45038 15.2635 9.68756 15.3662 9.91543 15.4648C10.1327 15.5589 10.3415 15.6493 10.651 15.6435C11.3084 15.6316 11.7195 15.0501 12.1187 14.4564C12.5528 13.8155 12.7439 13.1954 12.7726 13.1022L12.7759 13.0917C12.7751 13.091 12.7696 13.0884 12.7599 13.0839L12.7599 13.0839L12.7598 13.0839C12.6127 13.0155 11.5073 12.5023 11.4964 11.1333C11.4853 9.98438 12.3665 9.40176 12.5112 9.30609C12.5204 9.29999 12.5267 9.29587 12.5295 9.29371C11.9659 8.45161 11.0854 8.35666 10.7801 8.33281ZM17.63 6.67876C19.3398 6.67876 20.5304 7.8695 20.5304 9.60314C20.5304 11.343 19.3153 12.5399 17.5871 12.5399H15.694V15.5815H14.3262V6.67876H17.63ZM15.6943 11.3799H17.2638C18.4546 11.3799 19.1324 10.7322 19.1324 9.60928C19.1324 8.48648 18.4546 7.84482 17.2699 7.84482H15.6943V11.3799ZM23.276 11.8181C21.7492 11.9045 20.8882 12.6016 20.8882 13.7369C20.8882 14.9029 21.7676 15.6926 23.0256 15.6926C23.8683 15.6926 24.6806 15.2361 25.053 14.5142H25.0834V15.5816H26.3475V11.1086C26.3475 9.8068 25.3522 8.9739 23.795 8.9739C22.2072 8.9739 21.218 9.83762 21.1447 11.0099H22.3905C22.5064 10.4299 22.9827 10.0598 23.7463 10.0598C24.5522 10.0598 25.0347 10.4917 25.0347 11.2135V11.7132L23.276 11.8181ZM25.0344 12.6388V13.1509C25.0344 13.9961 24.3138 14.6377 23.3917 14.6377C22.6833 14.6377 22.2192 14.2675 22.2192 13.7C22.2192 13.1447 22.665 12.7931 23.4527 12.7375L25.0344 12.6388ZM27.5404 16.8895V17.9692C27.6379 17.9876 27.9678 18 28.0778 18C29.409 18 30.0442 17.4941 30.5935 15.9208L32.9998 9.09109H31.6075L29.9829 14.3723H29.9586L28.3341 9.09109H26.9053L29.2258 15.5877C29.2258 15.5903 29.2058 15.6574 29.1825 15.736C29.1495 15.8472 29.1096 15.9815 29.1096 15.9888C28.9082 16.6551 28.5784 16.9141 27.9677 16.9141C27.8577 16.9141 27.6379 16.9141 27.5404 16.8895Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

ApplePayIcon.displayName = 'ApplePayIcon';
